import { type TypedUseSelectorHook, useSelector, useDispatch } from "react-redux";
import type { Dispatch, ReducersMapObject } from "redux";
import type { CommonSettingsActionsType } from "./actions/CommonSettingsActions";
import ModalReducer, { type ModalReducerType } from "./reducers/ModalReducer";
import type { CommonSettingsType } from "../settings/fetchCommonSettings";
import UtilReducer, { type UtilStateType } from "./reducers/UtilReducer";
import type { ModalActionsType } from "./actions/ModalActions";
import type { UtilActionsType } from "./actions/UtilActions";
import notificationReducer, { type NotificationReducerType } from "./reducers/NotificationReducer";
import type { NotificationActionsType } from "./actions/NotificationActions";
import type {
    RetailerSettingsActionsType,
    RetailerSettingsType,
} from "../../shared-logic/features/retailer/redux/RetailerSettingsSlice";
import CommonSettingsReducer from "./reducers/CommonSettingsReducer";
import { getInitStoreByReducers } from "./storeHelpers";

export type CommonActionsType =
    | CommonSettingsActionsType
    | UtilActionsType
    | ModalActionsType
    | NotificationActionsType
    | RetailerSettingsActionsType;

export type CommonDispatchType = Dispatch<CommonActionsType>;

export type CommonReducerType = {
    commonSettings: CommonSettingsType;
    utils: UtilStateType;
    modal: ModalReducerType;
    notification?: NotificationReducerType;
    retailerSettings?: RetailerSettingsType;
};

export const commonReducers: ReducersMapObject<CommonReducerType, any> = {
    commonSettings: CommonSettingsReducer,
    utils: UtilReducer,
    modal: ModalReducer,
    notification: notificationReducer,
};

export const useCommonDispatch = useDispatch<CommonDispatchType>;
export const useCommonSelector: TypedUseSelectorHook<CommonReducerType> = useSelector;

/**
 * ⚠️ This should only be used in common tests ⚠️
 */
export const commonClientStore = getInitStoreByReducers(commonReducers);
